import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import I2BPOS from '../projects/I2BPOS'
import KSIESS from '../projects/KSIESS'
import PetrokimiaWMS from '../projects/PetrokimiaWMS'
import NotFound from './utils/NotFound'
import Home from './Home'
import Resume from './Resume'
import Domiciline from './utils/Domiciline'
import Craft from './Craft'
import Contact from './Contact'
import FamilyContact from './FamilyContact'

export default function RouterPage() {
  return (
    <Router>
        <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/craft' element={<Craft/>} />
            <Route path='/contact' element={<Contact/>} />
            {/* <Route path='/family' element={<FamilyContact/>} /> */}

            {/* Project Route */}
            <Route path='/i2b-pos' element={<I2BPOS/>} />
            <Route path='/ksi-ess' element={<KSIESS/>} />
            <Route path='/petrokimia-wms' element={<PetrokimiaWMS/>} />
            
            <Route path='/resume' element={<Resume/>} />
            <Route path='/domiciline' element={<Domiciline/>} />

            <Route path='*' element={<NotFound/>} />
        </Routes>
     </Router>
  )
}